import { frontendURL } from 'dashboard/helper/URLHelper';
import Index from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/active-games-ai'),
    name: 'active_games_ai_index',
    component: Index,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
